import{FALLBACK_HANDLER_ID as r}from"../constants";export var isFallbackHandler=function(t){return t.getId()===r};